module.exports = __webpack_public_path__ + "static/media/bw-logo-blue.98e40bcc.svg";